/**
* @Description 文件功能说明：webSoket组件
* @Author CC
* @Time 2021/4/28
**/

/* HTML */
<template>
</template>

/* JS */
<script>
	import {Soket} from '@/global/global-websoket'
    export default {

	    /**
			* @Des 组件名
			* @Auth CC
			* @Date 2021/04/30
			*/
        name: "SubWebsoket",
        props:{
            // webSoket路径
            wsUrl: {
                type: String,
                default: function (){
                    return ''
                }
            },
            // webSoket key
            wsKey: {
                type: String,
                default: function (){
                    return '_soket'
                }
            },
            // 发送心跳包
            wsPingStr: {
            	type: String,
                default: ''
            },
            // 自动重新连接
            autoRecreatFlag: {
                type: Boolean,
                default: function (){
                    return true
                }
            },
            // 连接已打开
            wsOnopen: {
            	type: Function,
                default: null
            },
            // 连接已打开
            wsOnerror: {
            	type: Function,
                default: null
            },
            // 连接已打开
            wsOnclose: {
            	type: Function,
                default: null
            },
            // 数据推送
            wsOnmessage: {
            	type: Function,
                default: null
            },
            // 委托win方法 数据推送
            winMessageFn: {
            	type: Function,
            	default: function () {
            		return null
            	}
            }
        },
        data() {
        	return {
				websoket: new Soket(),
        	}
        },
        created() {
            // 设置参数
            this.websoket.setWsParams({
            	wsKey: this.wsKey,
            	wsPingStr: this.wsPingStr,
            	autoRecreatFlag: this.autoRecreatFlag,
            	wsOnmessage: this.wsOnmessage,
            	wsOnopen: this.wsOnopen,
            	wsOnerror: this.wsOnerror,
            	wsOnclose: this.wsOnclose
            });

            // 建立webSoket连接
            this.websoket.createSocket(this.wsUrl, this.wsKey);

            // 开启监听
			this.bindOnmessage();
        },
        mounted() {
        	
        },
        methods: {
            // 发送数据
            wsSend(message) {
            	this.websoket.sendWSPush(message);
            },
            // 发送心跳
            sendPing(time=0.5*60*1000, ping='ping') {
            	this.websoket.sendPing(time, ping);
            },
            // 监听 数据推送
            onMessage(e) {
            	this.winMessageFn && this.winMessageFn(e);
            	/*let fnName = this.winMessageFn;
            	fnName && this.$emit(fnName, e);*/
            },
            // 开启监听
            bindOnmessage() {
            	window.addEventListener('onmessageWS' + (this.wsKey ? this.wsKey : ''), this.onMessage);
            },
			// 关闭监听
			offOnmessage() {
				window.removeEventListener('onmessageWS' + (this.wsKey ? this.wsKey : ''), this.onMessage);
			}
        },
        // 销毁之前执行
        beforeDestroy() {
        	// 关闭webSoket
          	this.websoket.endWS();
        	// 关闭监听
			this.offOnmessage();
        },
        // 销毁
        destroyed() {
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/SubWebsoket.vue